import { computed, createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import useApis from './useApis';
import useApisV1 from './useApiV1';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.variable.min.css';
import useState from './useState';
import { ProviderModule } from './store/modules/provider.module';
import { hasAllChildren, hasAnyChildren, hasChild } from './utils/tool.util';

let instance: any = null;

function render (props?: any) {
  if (instance) {
    return;
  }

  if (props && props.data) {
    useApis(props.data.Apis);
    useApisV1(props.data.ApisV1);
    useState(props.data.$state);
  }

  instance = createApp(App);
  instance.provide('hasPermission', computed(() => {
    return p => {
      const permissions = ProviderModule.permissions
      return hasChild(p, permissions)
    }
  }))
  instance.provide('hasAllPermissions', computed(() => {
    return arr => {
      const permissions = ProviderModule.permissions
      return hasAllChildren(arr, permissions)
    }
  }))
  instance.provide('hasAnyPermissions', computed(() => {
    return arr => {
      const permissions = ProviderModule.permissions
      return hasAnyChildren(arr, permissions)
    }
  }))
  instance.use(Antd).use(store).use(router).mount('#app');
}

if (!(window as any).__POWERED_BY_QIANKUN__) {
  render();
}

export async function bootstrap (): Promise<void> {
  console.log('%c%s', 'color: green;', 'app bootstraped');
}

export async function mount (props?: any): Promise<void> {
  render(props);
}

export async function unmount (): Promise<void> {
  instance.unmount();
  instance = null;
}
